module.exports = __webpack_public_path__ + "static/img/3.e1575db.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/408/3.png
// module id = 485
// module chunks = 1